import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export interface EllipsesProps {
  context: {
    title?: string;
    content?: string;
    more?: string;
    less?: string;
  };
}

export interface EllipsesStates {
  title?: string;
  content?: string;
  more?: string;
  less?: string;
  showLess?: boolean;
}

export class Ellipses extends Component<EllipsesProps, EllipsesStates> {
  ref: any;
  constructor(props: any = {}) {
    super(props);
    this.state = this.props.context;
    this.resize = this.resize.bind(this);
    this.getBorder = this.getBorder.bind(this);
    this.clickMore = this.clickMore.bind(this);
    this.clickLess = this.clickLess.bind(this);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.resize();
    this.screenChange();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize() {
    const StateObj = JSON.parse(JSON.stringify(this.state));
    StateObj.content = this.props.context.content;
    StateObj.less = this.props.context.less;
    StateObj.more = this.props.context.more;
    if (StateObj.content.length > this.getBorder()) {
      StateObj.content = StateObj.content.substr(0, this.getBorder());
    }
    this.setState(() => StateObj);
  }

  getBorder() {
    if (this.ref.current.clientWidth < 720) {
      return 180;
    } else {
      return 250;
    }
  }

  clickMore() {
    const StateObj = JSON.parse(JSON.stringify(this.state));
    StateObj.content = this.props.context.content;
    StateObj['showLess'] = true;
    this.setState(() => StateObj);
  }

  clickLess() {
    const StateObj = JSON.parse(JSON.stringify(this.state));
    StateObj.content = this.props.context.content;
    StateObj.less = this.props.context.less;
    StateObj.more = this.props.context.more;
    StateObj['showLess'] = false;
    if (StateObj.content.length > this.getBorder()) {
      StateObj.content = StateObj.content.substr(0, this.getBorder());
    }
    this.setState(() => StateObj);
  }

  screenChange() {
    window.addEventListener('resize', this.resize);
  }

  render():
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {
    return (
      <div className="my-privileges-details-view__desc-continer" ref={this.ref}>
        {this.state.title && (
          <div
            className="my-privileges-details-view__desc-title"
            dangerouslySetInnerHTML={{ __html: memoSanitize(this.state.title) }}
          ></div>
        )}
        {this.state.content && (
          <div className="my-privileges-details-view__desc-detail">
            <span
              dangerouslySetInnerHTML={{
                __html: memoSanitize(this.state.content),
              }}
            ></span>
            {this.props.context.content &&
            this.props.context.content.length > this.state.content.length ? (
              <span>
                ...
                <span
                  className="more"
                  onClick={() => {
                    this.clickMore();
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  {this.state.more}
                </span>
              </span>
            ) : (
              ''
            )}
            {this.state.showLess ? (
              <span>
                &nbsp;
                <span
                  className="more"
                  onClick={() => {
                    this.clickLess();
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  {this.state.less}
                </span>
              </span>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    );
  }
}
